import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Flex = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  height: 48px;\n"])));
var RadioButtonLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 25%;\n  left: 4px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: white;\n  border: 1px solid ", ";\n"])), Theme.colors.darkgrey);
var RadioButtonInput = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline;\n  opacity: 0;\n  z-index: 1;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n  cursor: pointer;\n  &:hover ~ ", " {\n    background: ", ";\n    &::after {\n      content: \"\";\n      display: block;\n      border-radius: 50%;\n      width: 12px;\n      height: 12px;\n      margin: 6px;\n    }\n  }\n  &:checked + ", " {\n    background: ", ";\n    border: 1px solid ", ";\n    &::after {\n      content: \"\";\n      display: block;\n      border-radius: 50%;\n      width: 10px;\n      height: 10px;\n      margin: 6px;\n      box-shadow: 1px 3px 3px 1px ", ";\n      background: white;\n    }\n  }\n"])), RadioButtonLabel, Theme.colors.primaryShadow, RadioButtonLabel, Theme.colors.lightBlue, Theme.colors.lightBlue, Theme.colors.greyOpacity);
var LabelText = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  color: ", ";\n"])), Theme.colors.primary);
var RadioField = function RadioField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    active = _ref.active,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement(Flex, null, /*#__PURE__*/React__default.createElement(RadioButtonInput, {
    type: "radio",
    name: value,
    value: value,
    checked: active === value,
    onChange: onChange
  }), /*#__PURE__*/React__default.createElement(RadioButtonLabel, null), /*#__PURE__*/React__default.createElement(LabelText, null, label));
};
RadioField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  active: PropTypes.string,
  onChange: PropTypes.func
};

export { LabelText, RadioButtonInput, RadioButtonLabel, RadioField as default };
